import SyncNote from './SyncNote';

export default SyncNote;
